<section class="carousel">
    <ng-container *ngIf=" hotel_Image as item">
        <!-- <h3>{{item.name}}</h3> -->
        <div class="wrapper">
        <p [mat-dialog-close]="true" class="closeButton" mat-icon-button><mat-icon>close</mat-icon></p>
            <owl-carousel-o [options]="hotelOptions">
                <ng-container *ngFor="let subItem of item['property_images']">
                    <ng-template carouselSlide>
                    <img [src]="subItem.image_path" [alt]="item.name" class="img-fluid">
                    </ng-template>
                </ng-container>
            </owl-carousel-o>
        </div>
    </ng-container>
</section>
